import _ from 'lodash';

/**
 * Function to clean duplicate routes on vue routes definitions.
 * @param current Current routes
 * @param overrides Routes to override current one
 */
export default (current, overrides = [], mathBy = 'name') => {
  if (!current) {
    /* eslint-disable-next-line */
    console.error('cleanDuplicateRoutes Error: Missing current routes.');
  }

  return current
    .concat(overrides)
    .reduce((accumulator, currentValue) => {
      const isInAccumulator = accumulator
        .find(child => _.get(child, mathBy) === currentValue[mathBy]);

      if (!isInAccumulator) {
        return accumulator.concat(currentValue);
      }

      return accumulator.concat([]);
    }, []);
};
